import { AccountAPI } from "./apiUtils";

export const getCoachTimeReport = async (data) => {
    console.log(data);
    return await AccountAPI.post("/coach-time-off", data)};

export const setResponseTimeOffApi = async (request, data) => {
    // console.log(data);
    return await AccountAPI.post("/response-timeoff", request)}; 